import { v4 as uuidv4 } from "uuid";

export default function AllOptionsTable({
  pageType,
  optionsArr,
  votersArr,
  proConVote,
}) {
  switch (pageType) {
    case "pros-cons-vote":
      return <div className="pro-con-vote" data-testid='AllOptions'>
          {optionsArr.map((option) => (
            <div className="pro-con-list" key={uuidv4()}>
              <div className="vote-header"><h1>{option.option}</h1></div>
              <div className='options-container'>
                <>
                  <h2 className='htwo-pros'>Pros</h2>
                  {option.prosCons.pros.map(pro => <p key={uuidv4()}>{pro}</p>)}
                  <h2 className='htwo-cons'>Cons</h2>
                  {option.prosCons.cons.map(con => <p key={uuidv4()}>{con}</p>)}
                </>
              </div>
            </div>
          ))}
          <>
            <div className="vote-container">
              {votersArr.map((el) => {
                return (
                  <>
                    <h2 className='htwo-user'>{"User" + el.name}</h2>
                    <select 
                      onChange={proConVote} 
                      name={el.name}
                      className="pro-con-select">
                      <option>Place your vote</option>
                      {optionsArr.map((option) => (
                        <option key={uuidv4()}>{option.option}</option>
                      ))}
                    </select>
                  </>
                );
              })}
            </div>
          </>
        </div>
    default:
      break;
  }
}        
